export type AnyDate = string | number | Date;

export enum DateTimeEnum {
  DATE = 'date',
  TIME = 'time',
  TIME_SECONDS = 'time-seconds',
  DATE_TIME = 'datetime-local',
  TIME_DATE = 'timedate',
  DATE_TIME_SECONDS = 'datetime-seconds',
  DATE_TIMELINE = 'date-timeline',
  DATE_FULL = 'date-full',
  DATE_TIME_SECONDS_ALTERNATE = 'datetime-seconds-alernate',
  DATE_TIME_SECONDS_PERIM_FORMAT = 'datetime-seconds-perim-format',
}

export type TimeReference = 'days' | 'hours' | 'minutes' | 'seconds';

export type DateTimeRange = {
  from: Date;
  to: Date;
};

export const DATE_TIME_RANGE_PRESETS = [
  'LAST_24_HOURS',
  'ROLLING_WEEK',
  'LAST_MONTH',
  'ROLLING_MONTH',
  'LAST_QUARTER',
  'ROLLING_QUARTER',
  'LAST_YEAR',
  'ROLLING_YEAR',
  'CUSTOM',
] as const;

export type DateTimeRangePreset = (typeof DATE_TIME_RANGE_PRESETS)[number];

export const ISO_WITH_TIMEZONE = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
